<div class="tCol clickCol desktop" id="CellRegistered_{{ item.id }}">
    <span *ngIf="!registered && !systemManaged && !routerManaged">Not Registered</span>
    <span *ngIf="registered && !systemManaged && !routerManaged">Registered</span>
    <span *ngIf="routerManaged">See Router</span>
</div>
